import { render, staticRenderFns } from "./AppHeaderBrandNav.vue?vue&type=template&id=420fb535&"
import script from "./AppHeaderBrandNav.vue?vue&type=script&lang=js&"
export * from "./AppHeaderBrandNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports